import ServerErrorSection from '../../../../siteBaseSections/ServerErrorSection/ServerErrorSection';

export default function ExternalError() {
  return <ServerErrorSection />;
}
